<template>
  <Toast />

  <Dialog
    v-model:visible="activarModal"
    :style="{ width: '550px' }"
    header="SELECCIÓN DE LOTES Y VENCIMIENTO"
    class="p-fluid"
    :modal="true"
    @hide="closeModal"
  >
    <div class="field col-12 md:cold-12 text-center pb-2 border-bottom-1 surface-border">
      <span class="text-center block text-xl font-bold text-900 mb-1">
        {{ producto_fechas.descripcion }}
      </span>
      <span class="text-center block text-base text-600">
        Cantidad Total a Asignar: <strong class="text-orange-600">{{ !producto_fechas.pivot ? 0 : (producto_fechas.es_porcionado ? (producto_fechas.pivot.porciones + ' Porción(es)') : cantidadTotalAsignar() + (producto_fechas.cantidad_asignar != null ? ' g' : '')) }}</strong>
      </span>
    </div>
    <DataTable
      ref="dtFechaVence"
      :value="producto_fechas.fechas_vencimiento"
      editMode="cell"
      @cell-edit-complete="onChangeEditandoCelda"
      class="p-datatable-sm mt-3"
      stripedRows
      selectionMode="single click"
      showGridlines
    >
      <Column class="text-right" field="cantidad" header="CANTIDAD A TRASPASAR">
        <template #body="slotProps">
          <div v-if="slotProps.data.gramaje_unidad > 0">
            <span class="font-bold text-orange-600">{{ slotProps.data.porciones || Math.floor((slotProps.data.cantidad || 0) / slotProps.data.gramaje_unidad) }} Porción(es)</span>
            <small class="block text-500 font-normal">({{ slotProps.data.cantidad || 0 }}g total)</small>
          </div>
          <div v-else>
            <span class="font-bold text-blue-600">{{ convertirNumeroGermanicFormat(slotProps.data.cantidad || 0) }}</span>
          </div>
        </template>
        <template #editor="{ data }">
          <div v-if="data.gramaje_unidad > 0" class="p-fluid">
            <InputNumber
              :inputClass="'text-right font-bold text-orange-600'"
              :min="0"
              :max="data.porciones_disponibles != null && parseFloat(data.porciones_disponibles) > 0 ? parseFloat(data.porciones_disponibles) : 99999"
              v-model="data.porciones"
              @update:modelValue="(val) => {
                data.porciones = val !== null && val !== undefined && val !== '' ? parseFloat(val) : 0;
                data.cantidad = (data.porciones || 0) * (data.gramaje_unidad || 0);
              }"
              autofocus
            />
            <small class="text-xs text-500 block text-right mt-1" v-if="data.porciones > 0">
              = {{ (data.porciones || 0) * data.gramaje_unidad }}g total ({{ data.gramaje_unidad }}g/porción)
            </small>
          </div>
          <div v-else class="p-fluid">
            <InputNumber
              :inputClass="'text-right font-bold text-blue-600'"
              :min="0"
              :minFractionDigits="0"
              :maxFractionDigits="2"
              v-model="data.cantidad"
              autofocus
            />
          </div>
        </template>
      </Column>
      <Column
        class="text-center"
        field="fecha_vence"
        header="VENCIMIENTO"
      >
        <template #body="slotProps">
          {{ slotProps.data.fecha_vence ? slotProps.data.fecha_vence.toLocaleDateString() : '-' }}
          <!-- Solo informativo: la fecha es una estimación, el criterio final es de quien maneja el producto -->
          <small
            v-if="slotProps.data.disponible != null && esFechaPasada(slotProps.data.fecha_vence)"
            class="block text-xs text-500 font-normal"
          >
            (vencimiento estimado, verificar estado físico)
          </small>
          <!-- Lote nuevo (compras): solo ayuda a detectar un typo de fecha, no bloquea el guardado -->
          <small
            v-else-if="slotProps.data.disponible == null && esFechaPasada(slotProps.data.fecha_vence)"
            class="block text-xs text-500 font-normal"
          >
            (fecha ya pasada, verificar)
          </small>
        </template>
        <template #editor="{ data }">
          <Calendar
            v-model="data.fecha_vence"
            :showIcon="true"
            dateFormat="dd/mm/yy"
          />
          <small
            v-if="data.disponible == null && esFechaPasada(data.fecha_vence)"
            class="block text-xs text-500 font-normal mt-1"
          >
            (fecha ya pasada, verificar)
          </small>
        </template>
      </Column>
      <Column class="text-left" field="lote" header="LOTE ORIGEN">
        <template #body="slotProps">
          <strong class="text-800">{{ slotProps.data.lote }}</strong>
          <span v-if="slotProps.data.disponible != null" class="block text-xs font-bold text-green-600 mt-1">
            <template v-if="slotProps.data.gramaje_unidad > 0">
              Disponible: {{ slotProps.data.porciones_disponibles }} Porción(es) ({{ slotProps.data.disponible }}g)
            </template>
            <template v-else>
              Disponible: {{ slotProps.data.disponible }}
            </template>
          </span>
        </template>
        <template #editor="{ data }">
          <InputText v-model="data.lote" />
        </template>
      </Column>
      <Column style="width: 3rem">
        <template #header>
          <Button
            :disabled="!boton_agregar"
            class="p-button-rounded p-button-outlined"
            icon="pi pi-plus"
            v-tooltip.top="'Agregar nueva fecha'"
            @click="agregarFechaVence"
          />
        </template>
        <template #body="data">
          <Button
            class="p-button-rounded p-button-outlined p-button-danger"
            icon="pi pi-trash"
            v-tooltip.top="'Quitar fecha'"
            @click="eliminarFechaVence(data)"
          />
        </template>
      </Column>
    </DataTable>
    <template #footer>
      <Button
        label="CANCELAR"
        icon="pi pi-times"
        class="p-button-secondary p-button-lg"
        @click="closeModal"
        :disabled="!enviado ? false : true"
      />
      <Button
        label="GUARDAR LOTES"
        icon="pi pi-save"
        class="p-button-primary p-button-lg bg-orange-600 border-none hover:bg-orange-700"
        @click="registrarFechaVence"
        :loading="enviado"
      />
    </template>
  </Dialog>
</template>
<script>
export default {
  name: "FechaVence",
  emits: ["closeModal"],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    producto: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      enviado: false,
      activarModal: this.show,
      producto_fechas: this.producto,
      boton_agregar: true,
    };
  },
  methods: {
    eliminarFechaVence(data) {
      this.$confirm.require({
        message: `¿Está seguro de quitar la fecha?`,
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          this.producto_fechas.fechas_vencimiento.splice(data.index, 1);
        },
      });
    },
    onChangeEditandoCelda(e) {
      let { data, newValue, field } = e;
      if (field === 'porciones' && data.gramaje_unidad > 0) {
        data.porciones = parseFloat(newValue) || 0;
        data.cantidad = data.porciones * data.gramaje_unidad;
      } else {
        data[field] = newValue;
      }
    },
    esFechaPasada(fecha) {
      if (!(fecha instanceof Date) || isNaN(fecha)) return false;
      const hoy = new Date();
      hoy.setHours(0, 0, 0, 0);
      return fecha < hoy;
    },
    // Compras (insumos a granel) define cantidad_asignar en gramos; Traspaso no, y usa pivot.cantidad
    cantidadTotalAsignar() {
      if (this.producto_fechas.cantidad_asignar != null) return parseFloat(this.producto_fechas.cantidad_asignar) || 0;
      return parseFloat(this.producto_fechas.pivot ? this.producto_fechas.pivot.cantidad : 0) || 0;
    },
    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(numero);
    },
    closeModal() {
      this.$emit("closeModal");
    },
    registrarFechaVence() {
      this.enviado = true;
      if (this.verificarCantidad()) {
        this.$toast.add({
          severity: "success",
          summary: "Éxito",
          detail: "Se registraron los lotes asignados",
          life: 3000,
        });
        this.enviado = false;
        this.closeModal();
      } else {
        this.enviado = false;
      }
    },

    verificarCantidad() {
      for (let item of this.producto_fechas.fechas_vencimiento) {
        let cantItem = parseFloat(item.cantidad || 0);
        if (cantItem <= 0) {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "La cantidad asignada debe ser mayor a 0",
            life: 3000,
          });
          this.boton_agregar = false;
          return false;
        }
      }
      this.boton_agregar = true;
      return true;
    },

    agregarFechaVence() {
      let gramaje = 0;
      if (this.producto_fechas.fechas_vencimiento && this.producto_fechas.fechas_vencimiento.length > 0) {
        gramaje = parseFloat(this.producto_fechas.fechas_vencimiento[0].gramaje_unidad || 0);
      } else if (this.producto_fechas.gramaje_unidad) {
        gramaje = parseFloat(this.producto_fechas.gramaje_unidad || 0);
      }

      if (gramaje > 0) {
        let totalPorcionesRequeridas = 0;
        if (this.producto_fechas.pivot && this.producto_fechas.pivot.porciones != null) {
          totalPorcionesRequeridas = parseFloat(this.producto_fechas.pivot.porciones);
        } else if (this.producto_fechas.pivot && this.producto_fechas.pivot.cantidad) {
          totalPorcionesRequeridas = Math.floor(parseFloat(this.producto_fechas.pivot.cantidad) / gramaje);
        }

        let porcionesAsignadas = (this.producto_fechas.fechas_vencimiento || []).reduce((acc, curr) => {
          return acc + parseFloat(curr.porciones || (curr.cantidad ? Math.floor(curr.cantidad / gramaje) : 0));
        }, 0);

        let porcionesFaltantes = Math.max(0, totalPorcionesRequeridas - porcionesAsignadas);

        this.producto_fechas.fechas_vencimiento.push({
          cantidad: porcionesFaltantes * gramaje,
          porciones: porcionesFaltantes,
          gramaje_unidad: gramaje,
          fecha_vence: new Date(),
          lote: null,
        });
      } else {
        let totalCantidadRequerida = this.cantidadTotalAsignar();
        let cantidadAsignada = (this.producto_fechas.fechas_vencimiento || []).reduce((acc, curr) => {
          return acc + parseFloat(curr.cantidad || 0);
        }, 0);

        let cantidadFaltante = Math.max(0, totalCantidadRequerida - cantidadAsignada);

        this.producto_fechas.fechas_vencimiento.push({
          cantidad: cantidadFaltante,
          porciones: 0,
          gramaje_unidad: null,
          fecha_vence: new Date(),
          lote: null,
        });
      }
    },
  },
  watch: {
    show(value) {
      this.activarModal = value;
    },
    producto(value) {
      this.producto_fechas = value;
    },
  },
};
</script>
